import React, { Component} from 'react';
import { translate } from 'react-i18next';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import {bin} from 'react-icons-kit/icomoon/bin';
import SvgIcon from 'react-icons-kit';
import swal from 'sweetalert';
import { Table, Button } from 'react-bootstrap';

var Config = require('../../../config');

class UsualDonation extends Component{
	constructor(props) {
	    super(props);
	    this.addConvokePlace = this.addConvokePlace.bind(this);
	    this.state = {
	    	convoke_place:"",
	    	errorText_convoke_place:"",
	    	scholarships:[],
	    	jobProfiles:[],
	    	convocatoryPlaces:[],
	    	showCheckboxes: false,
	    	convoke:false,
	    };
	}

	//Consulta de servicios necesarios para la pantalla
	componentDidMount() {
		//llamada a servicio que trae los lugares de convocatoria
		fetch(Config.default.apiGateway.URL+'convoke_places?option=CONVOKE_ANNOUNCEMENT',{ 
		    method: 'get',
		    headers: new Headers({
		       	'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       	'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
		  	this.setState({
		      convocatoryPlaces: response
		    });
		})			
	}

	componentWillUnmount() {
		
	}

	selectFieldHandle = (id, name, event, index, value) => {
	    this.setState({[event.target.name]:event.target.value});
	}

	addConvokePlace(){
		if (this.state.convoke_place !== "" ) {
        	var flag = false;
 			var i=0;	       	

          	for (i = 0; i < this.props.state.placesAdded.length; i++) {
              if (this.props.state.placesAdded[i].id === parseInt(this.state.convoke_place,10)) {
                flag = true;
                break
              };
          	};

	        if (flag === true) {
	            swal('¡El lugar no se puede agregar!', '¡Ya se ingreso ese lugar!', 'error');
	        } else{
	        	var obj = {};
	            for (i = 0; i < this.state.convocatoryPlaces.length; i++) {
	        		if (this.state.convocatoryPlaces[i].id === parseInt(this.state.convoke_place,10)) {
		              		obj.name = this.state.convocatoryPlaces[i].name;
		              		obj.id = this.state.convocatoryPlaces[i].id;
		              	break;
	        		};
	        	};
	            this.props.addPlaceToList(obj);
	        };
                      
      } else{
        	swal('Atención!', '¡Debe seleccionar el lugar de convocatoria!', 'warning');
      };
	}

	//Evento de cambio en elementos formulario
	handleCheck = (event) => {
	    this.setState({[event.target.name]: event.target.checked});
	}

	render() {
		const { t } = this.props;
	    return (
	      	<div className="col-xs-12" style={{padding:"0px"}}>
	      		<div className="col-xs-12">
		        	<span className="span-min">{t('content.offers.form.convoke')}</span>
		        	<input className="form-check-input" type="checkbox" name="convoke" onKeyPress={(e) => this.props.validate(e)}
			        		value={ this.state.convoke} onChange={ this.handleCheck } style={{marginLeft:'5px'}}/>
			    </div>

	        	{this.state.convoke?
	        	<div>	
		        <fieldset className="col-xs-12">
		        	<legend > {t('content.offers.form.convoke')} </legend>

		        	<div className="col-xs-12" style={{paddingLeft:0}}>
			        	<span className="col-xs-12 col-sm-4 span-min" style={{paddingLeft:0}}>
				            {t('content.offers.form.convoke_by')}
				        </span>
		        	</div>
		        	<div className="col-xs-12" style={{paddingLeft:0}}>
				        
			        	<div className="col-xs-12 col-sm-2" style={{paddingLeft:0}}>
			        		<span className="span-min">{t('content.offers.form.letter')}</span>
		        			<input className="form-check-input" type="checkbox" name="letter" onKeyPress={(e) => this.props.validate(e)}
			        			value={ this.props.state.letter} onChange={ this.props.handleCheck } style={{marginLeft:'5px'}}/>
					   
					    </div>
					    <div className="col-xs-12 col-sm-2">
					    	<span className="span-min">{t('content.offers.form.phone')}</span>
		        			<input className="form-check-input" type="checkbox" name="phone" onKeyPress={(e) => this.props.validate(e)}
			        			value={ this.props.state.phone} onChange={ this.props.handleCheck } style={{marginLeft:'5px'}}/>
					    </div>
					    <div className="col-xs-12 col-sm-2">
					    	<span className="span-min">{t('content.offers.form.cel_phone')}</span>
		        			<input className="form-check-input" type="checkbox" name="cel_phone" onKeyPress={(e) => this.props.validate(e)}
			        			value={ this.props.state.cel_phone} onChange={ this.props.handleCheck } style={{marginLeft:'5px'}}/>
					    </div>
					    <div className="col-xs-12 col-sm-2">
					    	<span className="span-min">{t('content.offers.form.sms')}</span>
		        			<input className="form-check-input" type="checkbox" name="sms" onKeyPress={(e) => this.props.validate(e)}
			        			value={ this.props.state.sms} onChange={ this.props.handleCheck } style={{marginLeft:'5px'}}/>
					    </div>
					    <div className="col-xs-12 col-sm-2">
					    	<span className="span-min">{t('content.offers.form.email')}</span>
		        			<input className="form-check-input" type="checkbox" name="email" onKeyPress={(e) => this.props.validate(e)}
			        			value={ this.props.state.email} onChange={ this.props.handleCheck } style={{marginLeft:'5px'}}/>
					    </div>
				    </div>

				    <div className="col-md-12" style={{paddingLeft:0}}>
		                <div className="col-xs-12 col-sm-4" style={{paddingLeft:0}}>
		                	<span className="span-min">{t('content.offers.form.convoke_in')}</span>
							<select className="form-control" onKeyPress={(e) => this.props.validate(e)}
				             	value={ this.state.convoke_place } 
					        	onChange={ this.selectFieldHandle.bind(null,"id","convoke_place") }
				              	name="convoke_place" id="convoke_place" >
				              	<option value="" disabled>Seleccionar...</option>
				                {
				                this.state.convocatoryPlaces.map(function(t) {
				                  return <option key={t.id}  value={t.id} >{t.name} </option>;
				                })
				            }
			              	</select>
		                </div>
		                
		                <div className="col-xs-12 col-sm-1" style={{paddingLeft:15}}>
		                    <FloatingActionButton  mini={true} style={{margin: 20 }} onClick={this.addConvokePlace}>
		                      <ContentAdd/>
		                    </FloatingActionButton>    
		                </div>
		            </div>

		            <div className="col-xs-12 col-sm-5" style={{paddingLeft:0,marginBottom: 10,}}>  
		            	<Table responsive hover >
			                <thead>
			                  <tr>
			                    <th>{t('content.offers.form.id')}</th>
			                    <th>{t('content.generics.files.name')}</th>
			                    <th width={60}></th>
			                  </tr>
			                </thead>
			                <tbody>
			                 {this.props.state.placesAdded.map( (place, index) => (
			                    <tr key={index}>
			                      <td>{place.id}</td>
			                      <td>{place.name}</td>
			                      <td width={60} style={{textAlign: "center",padding: "2px",}}>
			                        <Button className="btn btn-info btn-xs" title="Eliminar" 
			                        style={{marginRight:'3px'}} onClick={(e) => this.props.removePlaceFromList(index, e)}>
			                            <SvgIcon icon={bin} style={{paddingTop:"3px"}}/>
			                        </Button>
			                      </td>
			                    </tr>
			                    ))}
			                </tbody>
			              </Table>
		            </div>
		        </fieldset>	
		        </div>
		        :null}
	      	</div>
	    );
	}
}

export default translate('translations')(UsualDonation);